import { useRecoilValue } from "recoil";
import DigitalAssets from "../../DigitalAsset";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { PERMISSIONS } from "../../../PermissionsConstants";
import { OFFICE_PERMISSIONS } from "../permission";

const OfficeDigitalAssetsTable = ({ data }) => {
  const userPermissions = useRecoilValue(permissionsSelector);

  const permissions = {
    canAdd: userPermissions.includes(
      PERMISSIONS.permission_carrieragreemnentmgmt_digitalassets_add,
    ),
    canEdit: userPermissions.includes(
      PERMISSIONS.permission_carrieragreemnentmgmt_digitalassets_edit,
    ),
    canDeactivate: userPermissions.includes(
      PERMISSIONS.permission_carrieragreemnentmgmt_digitalassets_delete,
    ),
    canDownload: userPermissions.includes(
      PERMISSIONS.permission_carrieragreemnentmgmt_digitalassets_download,
    ),
    canViewOffice: userPermissions.includes(
      OFFICE_PERMISSIONS.permission_carrieragreemnentmgmt_office_view,
    ),
  };

  return (
    <>
      <div>
        <div className="">
          <DigitalAssets
            officeCode={data?.officeCode}
            officeRecord={data}
            viewFromOffice
            permissions={permissions}
          />
        </div>
      </div>
    </>
  );
};
export default OfficeDigitalAssetsTable;
